var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.96 26.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.96,15c0,6.33-5.15,11.48-11.48,11.48S0,21.33,0,15c0-3.53,1.59-6.82,4.37-9.01.43-.34,1.06-.27,1.4.16.34.43.27,1.06-.16,1.4-2.29,1.81-3.61,4.52-3.61,7.44,0,5.23,4.25,9.48,9.48,9.48s9.48-4.25,9.48-9.48c0-2.92-1.31-5.63-3.61-7.44-.43-.34-.51-.97-.17-1.4.34-.43.97-.51,1.4-.17,2.78,2.19,4.37,5.48,4.37,9.01Zm-11.48-.76c.55,0,1-.45,1-1V1c0-.55-.45-1-1-1s-1,.45-1,1v12.24c0,.55.45,1,1,1Z",
    fill: "#624de3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.7042dffb6d6d5a0ece1fccd5cb94dbe9.svg";
export { ForwardRef as ReactComponent };